// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "async-hello-world" + "." + "22ae791d868e82fd0a38" + ".css";
};